import React from 'react'
import {Badge, Box, Link as ChakraLink, Stack, Text, useColorModeValue} from "@chakra-ui/react";
import {Link} from "gatsby";
import {Maybe} from "../../gql/types";

export interface PostPreviewFlatProps {
  link: string;
  date: string;
  readingTime: number;
  title: string;
  subtitle?: Maybe<string>;
  isNew?: boolean;
}

const PostPreviewFlat: React.FC<PostPreviewFlatProps> = ({link, date, readingTime, title, subtitle, isNew}) => {
  return (
    <Box>
      <ChakraLink as={Link} to={link} color={useColorModeValue('brand.700', 'green.400')} fontSize={'2xl'} fontFamily={'heading'} fontWeight={600} letterSpacing={1.4}>
        {title}
        {isNew && <Badge variant={'solid'} colorScheme={'brand'} ml={1} mt={-3}>New</Badge>}
      </ChakraLink>
      <Stack direction={'column'} spacing={1} mt={1}>
        <Text color={'gray.400'} fontSize={'sm'}>{date} · {readingTime}min read</Text>
        <Text color={'gray.400'}>{subtitle}</Text>
      </Stack>
    </Box>
  )
}

export default PostPreviewFlat
